export class Cultivation {

    Id: number;
    Name: string;
    Color: string;
    Code:string;

    /**
     * Init
     * @param id id
     * @param name nom
     * @param color couleur
     * @param code code
     */
    constructor(id: number, name: string,  color: string, code:string) {
       
        this.Id = id;
        this.Name = name;
        this.Color = color;
        this.Code = code
    }

}